// Display-only collapsing of the Versions list (owner ruling 2026-07-14, the
// "middle path"): ONE row per DRAFT label showing that label's LATEST version;
// every earlier version of the label is RETAINED and rendered by the caller
// inside a history expander on that row. NOTHING is deleted, promoted,
// re-pointed, or re-ordered underneath — the version model, audit trail, and
// all backend semantics (promote / dispatch / snapshot-dedup baseline = latest
// version) are untouched; this function only decides what the list SHOWS.
//
// Rules:
//  * grouping key = the RAW label; only *_draft labels collapse (a missing
//    label counts as current_draft — the same rule the display formatter uses);
//  * non-draft labels (execution_copy, ...) and single-member groups render
//    exactly as today (empty history);
//  * output preserves the list's chronological feel: groups are ordered by
//    their latest version_number ascending (the tab renders oldest-first),
//    and history inside a group is ascending too.
//
// Plain CommonJS on purpose: imported by RequestDetail (webpack interops) and
// required directly by the backend jest suite for the grouping tests.
function groupVersionsForDisplay(versions) {
  const list = Array.isArray(versions) ? versions : [];
  const isDraftLabel = (raw) => /_draft$/.test(raw || '');
  const groups = new Map(); // key -> members[]
  for (const v of list) {
    const raw = (v && v.rawLabel) || 'current_draft';
    const key = isDraftLabel(raw) ? 'label:' + raw : 'solo:' + String(v && v.id);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(v);
  }
  const out = [];
  for (const members of groups.values()) {
    const sorted = [...members].sort((a, b) => ((a && a.num) || 0) - ((b && b.num) || 0));
    out.push({ latest: sorted[sorted.length - 1], history: sorted.slice(0, -1) });
  }
  out.sort((a, b) => ((a.latest && a.latest.num) || 0) - ((b.latest && b.latest.num) || 0));
  return out;
}

module.exports = { groupVersionsForDisplay };
